module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-sidebar-wrapper"
  }, [_c('div', {
    staticClass: "modal-sidebar"
  }, [_c('div', {
    staticClass: "modal-sidebar-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('template_editor.template_editor')))]), _vm._v(" "), _c('span', {
    staticClass: "close-modal",
    attrs: {
      "title": "Close Template"
    },
    on: {
      "click": function($event) {
        _vm.$emit('closeTemplateSidebar')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('span', {
    staticClass: "hide-sidebar",
    on: {
      "click": function($event) {
        _vm.$emit('closeTemplateSidebar')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-right"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-template-tabs"
  }, [_c('li', {
    class: {
      'active': _vm.parentSidebarTab === 'setup'
    },
    on: {
      "click": function($event) {
        _vm.parentSidebarTab = 'setup';
        _vm.childSidebarTab = 'document'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('template_editor.sidebar_tabs.setup')))]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.parentSidebarTab === 'content'
    },
    on: {
      "click": function($event) {
        _vm.parentSidebarTab = 'content'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('template_editor.sidebar_tabs.content')))]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.parentSidebarTab === 'modules'
    },
    on: {
      "click": function($event) {
        _vm.parentSidebarTab = 'modules'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('template_editor.sidebar_tabs.modules')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-sidebar-body"
  }, [(_vm.parentSidebarTab === 'content') ? _c('div', [_c('p', {
    staticClass: "modal-sidebar-header-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.content')))]), _vm._v(" "), _c('ul', {
    staticClass: "content-blocks"
  }, [_c('draggable', {
    attrs: {
      "list": _vm.partsList,
      "options": {
        group: {
          name: 'omega',
          pull: 'clone',
          put: false
        },
        sort: false
      },
      "clone": _vm.cloneNewPart
    }
  }, _vm._l((_vm.partsList), function(part) {
    return _c('li', {
      key: part.id,
      staticClass: "part-list-button",
      on: {
        "click": function($event) {
          _vm.addPartToDocument(part)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "icon",
      class: part.icon
    }), _vm._v("\n                " + _vm._s(part.title) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "document-drag-zone"
    }, [_vm._v(_vm._s(_vm.$t('template_editor.drop_content_here')))])])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.parentSidebarTab === 'modules') ? _c('div', [_c('p', {
    staticClass: "modal-sidebar-header-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.modules')))]), _vm._v(" "), (_vm.modulesList !== false && _vm.modulesList.length <= 0) ? _c('div', {
    staticClass: "no-modules"
  }, [_c('img', {
    attrs: {
      "src": "/images/sad.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('proposal_editor_modal.no_modules')))])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "content-blocks"
  }, [_c('draggable', {
    attrs: {
      "list": _vm.modulesList,
      "options": {
        group: {
          name: 'omega',
          pull: 'clone',
          put: false
        },
        sort: false
      },
      "clone": _vm.cloneNewModule
    }
  }, _vm._l((_vm.modulesList), function(module) {
    return _c('li', {
      key: module.id,
      staticClass: "part-list-button",
      on: {
        "click": function($event) {
          _vm.addModuleToDocument(module)
        }
      }
    }, [_c('span', [_vm._v("\n                " + _vm._s(module.title) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "document-drag-zone"
    }, [_vm._v(_vm._s(_vm.$t('template_editor.drop_content_here')))])])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.parentSidebarTab === 'setup') ? _c('div', [_c('ul', {
    staticClass: "sidebar-template-subtabs"
  }, [_c('li', {
    class: {
      'active': _vm.childSidebarTab === 'document'
    },
    on: {
      "click": function($event) {
        _vm.childSidebarTab = 'document'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('template_editor.document')))])]), _vm._v(" "), (_vm.childSidebarTab === 'document') ? _c('div', [_c('p', {
    staticClass: "modal-sidebar-header-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.cover_layout')))]), _vm._v(" "), _c('ul', {
    staticClass: "cover-layout-options"
  }, [_c('li', {
    class: {
      'active': _vm.payload.cover.layout === 1 || !_vm.payload.cover.layout
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$set(_vm.payload.cover, 'layout', 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-layout-1"
  })])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.payload.cover.layout === 2
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$set(_vm.payload.cover, 'layout', 2)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-layout-2"
  })])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.payload.cover.layout === 3
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$set(_vm.payload.cover, 'layout', 3)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-layout-3"
  })])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.payload.cover.layout === 4
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$set(_vm.payload.cover, 'layout', 4)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-layout-4"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "modal-sidebar-header-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.cover_background')))]), _vm._v(" "), _c('ul', {
    staticClass: "cover-background-options"
  }, [_c('li', {
    class: {
      'active': !_vm.payload.cover.backgroundImage && _vm.payload.cover.backgroundColor === '#ffffff' && _vm.payload.cover.color === '#000000'
    },
    on: {
      "click": function($event) {
        _vm.$set(_vm.payload.cover, 'themeName', 'blank');
        _vm.payload.cover.backgroundImage = null;
        _vm.payload.cover.backgroundColor = '#ffffff';
        _vm.payload.cover.color = '#000000';
      }
    }
  }, [_vm._v("\n              Blank\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.payload.cover.backgroundImage
    },
    on: {
      "click": function($event) {
        _vm.$set(_vm.payload.cover, 'themeName', 'image');
        _vm.payload.cover.backgroundColor = null;
        _vm.payload.cover.backgroundImage = '/images/doc-placeholder.jpg';
        _vm.payload.cover.color = '#FFFFFF';
      }
    }
  }, [_vm._v("\n              Image\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.payload.cover.backgroundColor && _vm.payload.cover.backgroundColor !== '#ffffff'
    },
    on: {
      "click": function($event) {
        _vm.payload.cover.backgroundImage = null;
        _vm.payload.cover.backgroundColor = _vm.themes[0].backgroundColor;
        _vm.payload.cover.color = _vm.themes[0].color;
      }
    }
  }, [_vm._v("\n              Color\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payload.cover.backgroundImage),
      expression: "payload.cover.backgroundImage"
    }]
  }, [_c('p', {
    staticClass: "modal-sidebar-subheader-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.background_image')) + " "), _c('span', [_vm._v(_vm._s(_vm.$t('template_editor.recommended_size')))])]), _vm._v(" "), _c('dropzone', {
    on: {
      "upload": _vm.updateCoverBackgroundImage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payload.cover.backgroundColor),
      expression: "payload.cover.backgroundColor"
    }]
  }, [_c('p', {
    staticClass: "modal-sidebar-subheader-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.color_theme')))]), _vm._v(" "), _c('ul', {
    staticClass: "cover-bg-color"
  }, _vm._l((_vm.themes), function(theme) {
    return _c('li', {
      class: {
        'selected': _vm.isCoverThemeSelected(theme)
      },
      on: {
        "click": function($event) {
          _vm.changeCoverTheme(theme)
        }
      }
    }, [_c('span', {
      style: ({
        'background-color': theme.backgroundColor,
        'color': theme.color
      })
    }, [_vm._v("a")])])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "modal-sidebar-header-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.cover_alignment')))]), _vm._v(" "), _c('ul', {
    staticClass: "cover-alignment-options"
  }, [_c('li', {
    class: {
      'active': _vm.payload.cover.alignment === 'left'
    }
  }, [_c('i', {
    staticClass: "icon icon-align-left",
    on: {
      "click": function($event) {
        _vm.$set(_vm.payload.cover, 'alignment', 'left')
      }
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      'active': !_vm.payload.cover.alignment || _vm.payload.cover.alignment === 'center'
    }
  }, [_c('i', {
    staticClass: "icon icon-align-center",
    on: {
      "click": function($event) {
        _vm.$set(_vm.payload.cover, 'alignment', 'center')
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "modal-sidebar-header-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.document_font')))]), _vm._v(" "), _c('div', {
    staticClass: "font-options"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.documentFontOptions,
      "searchable": false,
      "showLabels": false
    },
    model: {
      value: (_vm.payload.options.documentFont),
      callback: function($$v) {
        _vm.$set(_vm.payload.options, "documentFont", $$v)
      },
      expression: "payload.options.documentFont"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "modal-sidebar-header-text"
  }, [_vm._v(_vm._s(_vm.$t('template_editor.paper_size')))]), _vm._v(" "), _c('ul', {
    staticClass: "paper-size-options"
  }, [_c('li', {
    class: {
      'active': _vm.payload.options.paperSize === 'a4'
    },
    on: {
      "click": function($event) {
        _vm.payload.options.paperSize = 'a4'
      }
    }
  }, [_vm._v("A4")]), _vm._v(" "), _c('li', {
    class: {
      'active': !_vm.payload.options.paperSize || _vm.payload.options.paperSize === 'letter'
    },
    on: {
      "click": function($event) {
        _vm.payload.options.paperSize = 'letter'
      }
    }
  }, [_vm._v("Letter")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-sidebar-footer"
  }, [_c('span', {
    staticClass: "actions",
    attrs: {
      "slot": "sidebar-footer"
    },
    slot: "sidebar-footer"
  }, [_c('a', {
    staticClass: "button is-primary is-large",
    on: {
      "click": function($event) {
        _vm.$emit('save')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('template_editor.save_template')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026ecb6e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/template-editor-sidebar.vue
// module id = 501
// module chunks = 0